import {
  types,
  ISearchPacksAction,
  ISearchPacksSuccessAction,
  IFailureAction,
  IQuery,
  IUpdateSkipQuery,
  IResetSearchAction,
} from '../types/search'

export const searchPacks = (query: IQuery): ISearchPacksAction => ({
  type: types.SEARCH_PACKS__STARTED,
  query,
})

export const searchPacksSuccess = (
  items: any[],
  totalCount: number
): ISearchPacksSuccessAction => ({
  type: types.SEARCH_PACKS__SUCCESS,
  items,
  totalCount,
})

export const searchPacksFailure = (message: string): IFailureAction => ({
  type: types.SEARCH_PACKS__FAILURE,
  message,
})

export const updateSkipQuery = (skip: number): IUpdateSkipQuery => ({
  type: types.UPDATE_SKIP_QUERY,
  skip,
})

export const resetSearch = (): IResetSearchAction => ({
  type: types.RESET_SEARCH,
})
